import React, { useState, useEffect } from 'react';
import { DatePicker } from 'antd';
import styles from './FrontDesk.module.css';
import apiService from '../api/apiService';
import moment from 'moment';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Helper function to check if a room is available
function isRoomAvailable(startDate, endDate, bookedDates) {
  const start = new Date(startDate);
  const end = new Date(endDate);

  for (let booking of bookedDates) {
    const bookingStart = new Date(booking.start);
    const bookingEnd = new Date(booking.end);

    if (
      (start >= bookingStart && start <= bookingEnd) ||
      (end >= bookingStart && end <= bookingEnd) ||
      (start <= bookingStart && end >= bookingEnd)
    ) {
      return false;
    }
  }
  return true;
}

// Filter rooms based on room type
function filterRoomsByType(rooms, activeRoomType) {
  return rooms.filter(
    room =>
      activeRoomType === 'all' ||
      room.room.bed_type.toLowerCase() === activeRoomType
  );
}

export function Bookingform({ setAvailData, hotelId }) {
  const [activeRoomType, setActiveRoomType] = useState('all');
  const [checkInDate, setCheckInDate] = useState();
  const [checkOutDate, setCheckOutDate] = useState();
  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [allRooms, setAllRooms] = useState([]);

  // Room types
  const roomTypes = [
    { id: 'all', label: 'All rooms' },
    { id: 'single', label: 'Single' },
    { id: 'double', label: 'Double' },
    { id: 'triple', label: 'Triple' },
    { id: 'vip', label: 'VIP' },
  ];

  const fetchRoomsAndBookings = async () => {
    try {
      const roomsResponse = await apiService.get(`/rooms/?hotel=${hotelId}`);
      const bookingsResponse = await apiService.get(
        `/bookings/?hotel=${hotelId}`
      );

      const roomsWithBookings = roomsResponse.map(room => {
        const roomBookings = bookingsResponse
          .filter(booking => Number(booking.room.id) === Number(room.id))
          .map(booking => ({
            start: booking.check_in,
            end: booking.check_out,
          }));

        return {
          ...room,
          bookedDates: roomBookings,
        };
      });

      setAllRooms(roomsWithBookings);
      //handleCheckAvailability();
      //console.log(roomsWithBookings);
    } catch (error) {
      console.error('Error fetching rooms or bookings:', error);
    }
  };

  // Fetch rooms and bookings using axios
  useEffect(() => {
    fetchRoomsAndBookings();
  }, []);

  const availableRooms = allRooms.map(room => {
    const isAvailable = isRoomAvailable(
      checkInDate,
      checkOutDate,
      room.bookedDates
    );

    room.status = isAvailable ? 'Available' : 'Occupied';
    return {
      room: room,
      isAvailable: isAvailable ? 'Available' : 'Occupied',
    };
  });

  const handleCheckAvailability = () => {
    if (!checkInDate || !checkOutDate) {
      toast.error('Please select check-in and check-out dates!');
      return;
    }

    var generatedData = availableRooms;
    console.log(generatedData);

    const filteredRooms = filterRoomsByType(generatedData, activeRoomType);
    setAvailData(filteredRooms);
  };

  // Disable past dates and enforce check-out must be after check-in
  const disableCheckInDates = current => {
    return current && current < moment().startOf('day');
  };

  const disableCheckOutDates = current => {
    return current && current <= moment(checkInDate).startOf('day');
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className={styles.bookingContainer}>
            <div className={styles.dateSection}>
              <div className="row g-3 g-md-2">
                <div className="col-md-6 col-12">
                  <div className={styles.inputWrapper}>
                    <label className={styles.inputLabel}>Check-in</label>
                    <DatePicker
                      className={styles.inputField}
                      value={checkInDate ? moment(checkInDate) : null}
                      onChange={(_, dateString) => setCheckInDate(dateString)}
                      format="YYYY-MM-DD"
                      disabledDate={disableCheckInDates}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className={styles.inputWrapper}>
                    <label className={styles.inputLabel}>Check-out</label>
                    <DatePicker
                      className={styles.inputField}
                      value={checkOutDate ? moment(checkOutDate) : null}
                      onChange={(_, dateString) => setCheckOutDate(dateString)}
                      format="YYYY-MM-DD"
                      disabledDate={disableCheckOutDates}
                    />
                  </div>
                </div>
              </div>
            </div>

            <button
              className={styles.submitButton}
              onClick={handleCheckAvailability}
            >
              Check availability
            </button>

            <div className={styles.bookingContent}>
              <div className={styles.roomTypeContainer}>
                {roomTypes.map(room => (
                  <button
                    key={room.id}
                    className={`${styles.roomTab} ${
                      activeRoomType === room.id ? styles.activeTab : ''
                    }`}
                    onClick={() => setActiveRoomType(room.id)}
                  >
                    {room.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
